import React from 'react'
import SkuCardBottom from 'components/SkuListCard/SkuCardBottom'

import styled from 'styled-components'
import theme from 'theme'
import defaultImg from '/static/images/image-placeholder.png'
import redeemImg from '/static/images/big@2x.png'
import receiveImg from '/static/images/receive@2x.png'

import { useUserAgentStore } from 'store/userAgentStore'
import { toJS } from 'mobx'

const MerchantSkuCard = (props) => {
  const { data, onclickSlide } = props
  const userAgentStore = useUserAgentStore()
  const { featureFlags } = userAgentStore
  const paymentIntegration = toJS(featureFlags.paymentIntegration)
  const {
    detailImageUrl,
    name,
    amount,
    pointsValue,
    publishEndAt,
    stat: stockInfo,
  } = data
  const { availableNum } = stockInfo
  const outOfStockImg = !paymentIntegration
    ? pointsValue
      ? redeemImg
      : receiveImg
    : redeemImg
  return (
    <CardWapper className="swiper-slide" onClick={onclickSlide}>
      <ContentCard
        coverImage={detailImageUrl}
        title={name}
        maskImage={outOfStockImg}
        showMaskImg={availableNum === 0}
      >
        <SkuCardBottom
          paymentIntegration={paymentIntegration}
          pointsValue={pointsValue}
          publishEndAt={publishEndAt}
          amount={amount}
        />
      </ContentCard>
    </CardWapper>
  )
}

const ContentCard = ({
  children,
  showMask,
  showMaskImg,
  maskImage,
  title,
  coverImage,
  onClick,
}) => {
  return (
    <CardContainer showMask={showMask} onClick={onClick}>
      <ImgWapper showMaskImg={showMaskImg}>
        <CoverImage
          src={coverImage || defaultImg}
          onerror={`this.src=${defaultImg}`}
        />
        {(showMask || showMaskImg) && <InvalidTag unUseableImg={maskImage} />}
      </ImgWapper>
      <SkuInfoWrapper>
        <SkuTitle>{title}</SkuTitle>
        <CardBottom>{children}</CardBottom>
      </SkuInfoWrapper>
    </CardContainer>
  )
}

const CardWapper = styled.div`
  width: auto;
`
export const CardContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  cursor: pointer;
  background-color: ${theme.color.white};
  &::after {
    content: ' ';
    display: ${(p) => (p.showMask ? 'block' : 'none')};
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background-color: ${(p) => p.showMask && 'rgba(255,255,255,0.6)'};
  }
`
const ImgWapper = styled.div`
  width: 100%;
  height: 0;
  /* height = width * 56% */
  padding-bottom: 56%;
  position: relative;
  border-bottom: 1px solid ${theme.color.grey50};
  opacity: ${(p) => p.showMaskImg && 0.5};
`
const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
  position: absolute;
  top: 0;
  left: 0;
`
const InvalidTag = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  background: url(${(p) => p.unUseableImg}) no-repeat center;
  background-size: 50%;
  z-index: 2;
`

const SkuInfoWrapper = styled.div`
  padding: 16px;
  border-radius: 0 0 4px 4px;
`
const SkuTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${theme.color.dark200};
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.5;
  /* stylelint-disable value-no-vendor-prefix */
  display: -webkit-box;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 48px;
`

const CardBottom = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  min-height: 2em;
`

export default MerchantSkuCard
